import Vue from 'vue'
import Vuetify from 'vuetify'
import "vuetify/dist/vuetify.min.css";
//import 'vuetify/src/stylus/app.styl'
// Translation provided by Vuetify (typescript)
import en from 'vuetify/es5/locale/en'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import "@mdi/font/css/materialdesignicons.css";
// Your own translation file
import fr from 'vuetify/es5/locale/fr'

Vue.use(Vuetify)

export default new Vuetify({
    lang: {
        locales: { en, fr },
        current: 'en',
    },
    theme: {
        themes: {
            light: {
                primary:  "#008080",
                secondary: "#36454F",
                accent: "#E30B5C",
                // success: "#008000",
                // warning: "#FFA500"
            }
        }
    },
    icons: {
        iconfont: 'mdi'
    }
})